import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const ModalBodyWrapper = styled.ul`
  height: 70vh;
  padding-right: ${Spacing.S12};
  padding-bottom: ${Spacing.S24};
  padding-left: ${Spacing.S12};
  overflow-y: auto;
  scrollbar-gutter: stable;
`
